import { Modal } from 'semantic-ui-react';

const ModalContent = Modal.Content;

export { Modal, ModalContent };
